import React, { useContext } from "react"
import { SendMessageFormContext } from "#/components/talk-to-carrot/send-message/SendMessage"
import { BenefitEnrollmentModalContinueButton } from "../shared"
import { FormattedMessage, useIntl } from "react-intl"
import { Button, Typography, useTheme, Box, Stack } from "@carrotfertility/carotene-core"
import { PiiText } from "#/services/tracking"
import { ltr } from "#/services/locale/bidirectional-text"

interface MessageSentProps {
  close?: boolean
  onClick?: () => void
  header?: string
  body?: string
}

const MessageSent = (props: MessageSentProps) => {
  const { personalEmail, employeeEmail, partnerEmail, sentFromPartnerEmail } = useContext(SendMessageFormContext)
  const intl = useIntl()
  const { close = false, onClick = null, header = intl.formatMessage({ defaultMessage: "Received!" }), body } = props

  function getIntlBodyText(): any {
    if (sentFromPartnerEmail)
      return (
        <FormattedMessage
          defaultMessage="We'll get back to you at {email}, your partner's email."
          values={{
            email: <PiiText>{ltr(partnerEmail)}</PiiText>
          }}
        />
      )
    else if (personalEmail)
      return (
        <FormattedMessage
          defaultMessage="We'll get back to you at {email}, your preferred email."
          values={{
            email: <PiiText>{ltr(personalEmail)}</PiiText>
          }}
        />
      )
    else
      return (
        <FormattedMessage
          defaultMessage="We'll get back to you at {email}, your account email."
          values={{
            email: <PiiText>{ltr(employeeEmail)}</PiiText>
          }}
        />
      )
  }
  const theme = useTheme()
  return (
    <Stack paddingY={theme.spacing(theme.tokens.spacing.md)} spacing={theme.spacing(theme.tokens.spacing.md)}>
      <Typography variant="h3">{header}</Typography>
      <Typography>{body ?? getIntlBodyText()}</Typography>
      {close ? (
        <Box display="flex" justifyContent="center">
          <Button onClick={onClick}>
            <FormattedMessage defaultMessage="Close" />
          </Button>
        </Box>
      ) : (
        <BenefitEnrollmentModalContinueButton onClick={onClick} />
      )}
    </Stack>
  )
}

export { MessageSent }
